import React, {
  useCallback,
  useMemo,
} from 'react'

import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import {
  Button,
  Checkbox,
} from '@termly/react-components'

import UINames from 'constants/ui-names'

import { useConsentConfig } from 'components/ConsentConfigProvider'
import { useDisplayManager } from 'components/DisplayManager'

import TCFLabel from './TCFLabel'

import Locale from './locale'
import Styles from './styles.scss'


export default function TCFConsentRow(props) {
  const {
    handleConsentChange,
    isChecked,
    row,
    showVendorCount = true,
    vendorCount,
    vendorType,
  } = props

  const { theme } = useConsentConfig()
  const { pushActiveUI } = useDisplayManager()

  const style = useMemo(() => ({
    color: theme.color,
    fontFamily: theme.font_family,
  }), [theme])

  const handleOpenDetailsView = useCallback(() => {
    const uiName = ( vendorType === 'gacm' ) ? UINames.GACM_DETAILS : UINames.TCF_DETAILS

    pushActiveUI(uiName, {
      details: row,
    })
  }, [pushActiveUI, row, vendorType])

  const label = useMemo(() => {
    return (
      <TCFLabel
        showCount={ showVendorCount }
        title={ row.name }
        vendorCount={ vendorCount }
      />
    )
  }, [row, showVendorCount, vendorCount])

  const handleCheckboxClick = useCallback(({ checked }) => {
    handleConsentChange(row.id, checked)
  }, [handleConsentChange, row])

  const focusID = `details-${ vendorType || 'tcf' }-${ row.id }`

  return (
    <div className={ Styles.root }>
      <div className="tcfConsentRowContainer">
        <div className={ Styles.row }>
          <Checkbox
            checked={ isChecked }
            className="tcfConsentRowCheckbox"
            handleClick={ handleCheckboxClick }
            label={ label }
            name={ row.name }
          />

          <Button
            aria-haspopup="dialog"
            className={ Styles.detailsButton }
            data-focus-id={ focusID }
            handleClick={ handleOpenDetailsView }
            style={ style }
            type="text"
          >
            <FormattedMessage
              { ...Locale.details }
            />
          </Button>
        </div>
      </div>
    </div>
  )
}

TCFConsentRow.propTypes = {
  handleConsentChange: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  row: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,

  handleDetailsClick: PropTypes.func,
  showVendorCount: TCFLabel.propTypes.showCount,
  vendorCount: TCFLabel.propTypes.vendorCount,
  vendorType: PropTypes.string,
}
